import gameBall1x from './gameBall.png';
import gameBall2x from './gameBall@2x.png';
import gameBall3x from './gameBall@3x.png';
import gameBall4x from './gameBall@4x.png';

import siteBall1x from './siteBall.png';
import siteBall2x from './siteBall@2x.png';
import siteBall3x from './siteBall@3x.png';
import siteBall4x from './siteBall@4x.png';

const gameBall = {
    1: gameBall1x,
    2: gameBall2x,
    3: gameBall3x,
    4: gameBall4x,
};

const siteBall = {
    1: siteBall1x,
    2: siteBall2x,
    3: siteBall3x,
    4: siteBall4x,
};

export { gameBall, siteBall };
